import type { SVGProps } from 'react';
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Home_svg__a)">
      <path
        d="M14.765 6.102 8.003 1 1.235 6.102A.73.73 0 0 0 1 6.599v7.79a.61.61 0 0 0 .609.61h4.058v-3.265a2.333 2.333 0 1 1 4.666 0V15h4.058a.61.61 0 0 0 .609-.608V6.599a.74.74 0 0 0-.235-.497"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Home_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHome;
